import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

export const AdBanner = () => {
  const { user } = useAuth();
  const [ads, setAds] = useState([]);
  const [currentAdIndex, setCurrentAdIndex] = useState(0);

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const userLoc = user?.location || "";
        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/ads?location=${encodeURIComponent(userLoc)}`);
        setAds(data);
        if (data.length > 0) {
          let sessionAdIndex = sessionStorage.getItem('current_ad_index');
          if (sessionAdIndex === null) {
            let persistentIndex = parseInt(localStorage.getItem('next_ad_index') || '0', 10);
            sessionAdIndex = persistentIndex % data.length;
            localStorage.setItem('next_ad_index', (persistentIndex + 1).toString());
            sessionStorage.setItem('current_ad_index', sessionAdIndex);
          }
          setCurrentAdIndex(parseInt(sessionAdIndex, 10));
        }
      } catch (e) {
        console.error("Failed to fetch ads", e);
      }
    };
    fetchAds();
  }, [user]);

  if (ads.length === 0) {
    return null; // Don't show anything if no ads
  }

  const activeAd = ads[currentAdIndex];
  const imageUrl = `${process.env.REACT_APP_BACKEND_URL}/api/public/ads/image/${activeAd._id}`;

  return (
    <div className="w-full my-6 flex justify-center" data-testid="custom-ad-banner">
      <a href={activeAd.link} target="_blank" rel="noopener noreferrer" className="block relative w-full overflow-hidden rounded-sm border border-border group">
        <div className="absolute top-2 left-2 z-10 text-[10px] font-bold tracking-widest text-muted-foreground bg-background px-2 py-0.5 border border-border">ADVERTISEMENT</div>
        <img 
          src={imageUrl} 
          alt="Advertisement" 
          className="w-full object-cover max-h-[120px] transition-transform duration-300 group-hover:scale-105"
        />
      </a>
    </div>
  );
};